import React, {useState} from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { MdClose, MdMenu } from "react-icons/md";


export default function Navbar() {

 

  const Navbar = styled.ul`
    position: fixed;
    z-index: 100;
    top: 0;
    width: 100%;
    padding: 0.1rem 0;
    background: linear-gradient(
      90deg,
      rgba(79, 70, 229, 1) 0%,
      rgba(147, 51, 234, 1) 46%,
      rgba(219, 39, 119, 1) 100%
    );
    box-shadow: inset 0px 0px 10px indigo;
    ul {
      max-width: 1200px;
      margin: 0 auto;
      width: 90%;
      text-align: center;
      li {
        display: inline-block;
        border-radius: 8px;
        transition: 0.7s ease background-color;
        color: white;
        margin: 0.2rem;
        &:hover {
          background-color: #cb33ea;
        }
      }
      a {
        display: inline-block;
        padding: 1rem 1rem;
        font-size: 1rem;
        outline: none;
      }
      .active {
        background-color: #cb33ea;
        border-radius: 15px;
        transtion: 0.5s ease-in background-color;
      }
    }
    .mobile-menu-icon {
      position: absolute;
      right: 1rem;
      top: 1rem;
      width: 1rem;
      cursor: pointer;
      display: none;
      outline: none;
      color: white;
      margin-right: 1rem;
    }
    .closeNavIcon {
      color: white;
      display: none;
    }
    @media only screen and (max-width: 768px) {
      .hide-item {
        transform: translateY(calc(-100% - 1rem));
        
      }
      .mobile-menu-icon {
        display: block;
        
      }
      .navItems {
        position: fixed;
        --top: 0;
        transition: 0.3s ease transform;
        background-color: #29048a;
        padding: 3rem;
        width: 80%;
        max-width: 100vh;
        border-radius: 0 0 15px 15px;
        height: 28.6rem;
        position: absolute;
        right: 0rem;
        box-shadow: inset 0px 0px 10px white;
        top: var(--top);
        .closeNavIcon {
          display: block;
          width: 3rem;
          margin: 0 0 0 auto;
          cursor: pointer;
          position: absolute;
          right: -0.2rem;
          top: 1rem;
          * {
            pointer-event: none;
          }
        }
        li {
          display: block;
          margin-bottom: 1rem;
        }
      }
    }
  `;

  const [showNav, SetShowNav] = useState(false);

  return (
    <Navbar className="">
      <div className="mobile-menu-icon"
      onClick={() => SetShowNav(!showNav)}
      role='button'
      onKeyDown={() => SetShowNav(!showNav)}
      tabIndex={0}
      >
        <MdMenu className=" w-9 h-9" />
      </div>

      <ul className={(!showNav) ? 'navItems hide-item' : 'navItems'}  >
        <div className="closeNavIcon"
        onClick={() => SetShowNav(!showNav)}
        role='button'
        onKeyDown={() => SetShowNav(!showNav)}
        tabIndex={0}
        >
          <MdClose className="w-9 h-9 " />
        </div>

        <li className="">
          <NavLink className=" hover:text-white" to="/" exact>
            HOME
          </NavLink>
        </li>
        <li className="">
          <NavLink className="hover:text-white" to="/aboutme">
            ABOUT ME
          </NavLink>
        </li>
        <li className="">
          <NavLink className="hover:text-white " to="/experience">
            EXPERIENCE
          </NavLink>
        </li>
        <li className="">
          <NavLink className="hover:text-white " to="/projects">
            PROJECTS
          </NavLink>
        </li>
        <li className="">
          <NavLink
            className="hover:text-white border-2 border-purple-300 rounded-xl "
            to="/hireme"
          >
            HIRE ME
          </NavLink>
        </li>
      </ul>
    </Navbar>
  );
}
